export default {
  title: 'Inicia tu suscripción',
  title_confirm: 'Confirma tu plan',
  step: 'Paso {{current}} de {{total}}',
  subtitle: '{{name}} · 1 ubicación',
  trial_badge: '{{days}} días gratis',
  trial_headline: 'Primeros {{days}} días gratis',
  then_price: 'Luego {{price}} / mes por ubicación · impuestos incluidos',
  price_per_month: '{{price}} / mes',
  price_terms: 'Por ubicación, facturado mensualmente · impuestos incluidos',
  tier_upsell:
    'Escala a más de {{threshold}} locales activos y la tarifa de todos tus locales baja a {{price}} / mes por local, automáticamente.',
  tier_active: 'Tarifa por volumen — {{threshold}}+ ubicaciones activas',
  due_today: 'Vencimiento hoy',
  from_date: 'Desde {{date}}',
  no_charge_today: 'No se te cobrará hoy.',
  no_charge_until: 'No se te cobrará hoy. Cancela a más tardar el {{date}} y no pagarás nada.',
  active: '{{plan}} está activo para este restaurante.',
  active_with_trial: '{{plan}} está activo para este restaurante, gratis hasta {{date}}.',
  terms:
    'Acepto los <a href="{{terms_url}}" target="_blank" rel="noreferrer">Términos de la Plataforma de Socios de FoodAmigos</a>, incluyendo activación, cancelación y reembolsos.',
  error: 'No pudimos completar la compra. Inténtalo de nuevo.',
  loading: 'Comprobando el plan de este restaurante…',
  load_error: 'No pudimos comprobar el plan de este restaurante.',
  unavailable:
    'Este producto no está disponible para este restaurante. Contacta con tu gestor de cuenta de FoodAmigos.',
  products: {
    online_ordering: {
      features: {
        ordering: {
          title: 'Pedidos en línea',
          description: 'Pedidos directos en el sitio web propio del restaurante',
        },
        reservations: {
          title: 'Reservas de mesa',
          description: 'Los clientes reservan una mesa directamente en línea',
        },
        marketing: {
          title: 'Suite de Marketing',
          description: 'Creador de ofertas, programa de puntos de fidelidad y respuestas con IA a reseñas de Google',
        },
        pricing: {
          title: '0% de comisión, sin cuota de instalación',
          description: 'Una licencia por ubicación, facturada mensualmente',
        },
      },
    },
    mobile_app: {
      features: {
        app: {
          title: 'La app con marca propia del restaurante',
          description: 'En App Store y Google Play',
        },
        engagement: {
          title: 'Notificaciones push y fidelidad',
          description: 'Haz que los clientes vuelvan con ofertas y puntos',
        },
        ordering: {
          title: 'Pedidos con 0% de comisión',
          description: 'Pedidos directos desde la app',
        },
        apple: {
          title: 'Se requiere cuenta de Apple Developer',
          description: '$99/año, pagados a Apple, con la entidad legal del restaurante',
        },
      },
    },
    ai_website: {
      title: 'Suscripción al Creador de Sitios Web',
      subtitle_domain: 'Publica el sitio web de {{name}} en {{domain}}',
      features: {
        domain: {
          title: 'Tu sitio web, publicado en tu propio dominio',
          description: 'El sitio web con marca propia del restaurante',
        },
        ai: {
          title: 'Creado y actualizado con IA',
          description: 'Crea páginas, textos e imágenes para el restaurante en minutos',
        },
        ordering: {
          title: 'Pedidos y reservas integrados',
          description: 'Los clientes piden y reservan mesa directamente desde el sitio web',
        },
        pricing: {
          title: 'Sin cuota de instalación',
          description: 'Una licencia por ubicación, facturada mensualmente',
        },
      },
    },
    storefront: {
      title: 'Suscripción al Creador de Sitios Web',
      subtitle_domain: 'Publica el sitio web de {{name}} en {{domain}}',
      features: {
        domain: {
          title: 'Tu sitio web, publicado en tu propio dominio',
          description: 'El sitio web con marca propia del restaurante',
        },
        ai: {
          title: 'Creado y actualizado con IA',
          description: 'Crea páginas, textos e imágenes para el restaurante en minutos',
        },
        ordering: {
          title: 'Pedidos y reservas integrados',
          description: 'Los clientes piden y reservan mesa directamente desde el sitio web',
        },
        pricing: {
          title: 'Sin cuota de instalación',
          description: 'Una licencia por ubicación, facturada mensualmente',
        },
      },
    },
  },
  payment_method: {
    label: 'Tu método de pago como socio',
    on_file: 'Tarjeta guardada',
    pending_title: 'Confirmando tu método de pago',
    pending: 'Stripe todavía está confirmando la tarjeta que acabas de añadir. Esto puede tardar un momento.',
    still_pending: 'Todavía no. Espera un momento y vuelve a comprobarlo.',
    error: 'No pudimos abrir el formulario de pago. Inténtalo de nuevo.',
  },
  buttons: {
    close: 'Cerrar',
    continue_to_payment: 'Continuar al pago',
    start_trial: 'Iniciar prueba gratis de {{days}} días',
    subscribe: 'Iniciar suscripción',
    continue: 'Continuar',
    change: 'Cambiar',
    retry: 'Intentar de nuevo',
    check_again: 'Comprobar de nuevo',
    add_again: 'Añadir otra tarjeta',
  },
};
